import { useNavigate, useOutletContext } from 'react-router-dom';
import { AddProviderAndPhoneNumber } from '../../components/signup/AddProviderAndPhoneNumber';
import { PageContainer } from '../../components/signup';
import { AccountSetupOutletContext } from '../../components/signup/types';

const AddProviderAndPhoneNumberPage = () => {
  const navigate = useNavigate();
  const { formState, updateFormState } = useOutletContext<AccountSetupOutletContext>();

  const handleNext = () => {
    navigate('/onboarding');
  };

  return (
    <PageContainer data-fs-unmask="true">
      <AddProviderAndPhoneNumber
        onNext={handleNext}
        defaultValues={formState}
        onFormDataUpdate={(data) =>
          updateFormState({
            npi: data.npi,
            office_phone_number: data.office_phone_number,
            fax_number: data.fax_number,
          })
        }
      />
    </PageContainer>
  );
};

export default AddProviderAndPhoneNumberPage;
